import { Grid } from '@mui/material';
import './keep.styles.scss';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../contexts/cancellation.context';
import { freshDeskReport, setCookie } from '../../../utils/generaFunctions';

const Keep = () => {
    const {userInfo, cancelInfo, changeCancelInfo, setLoading} = useContext(CancelContext);
    useEffect(()=>{
        setCookie("cancellation-"+userInfo.email,"yes", 1/12);
        if(cancelInfo.reactivated || cancelInfo.welcomed){
            console.log(cancelInfo)
            changeCancelInfo({reactivated: false, welcomed: false});
            setLoading(false);
        } else {
            freshDeskReport(userInfo.email, userInfo.name, "Keep Subscription during Cancellation flow", "SysT1.0: Prevented", "SysT1.0: Prevented", "SysT1.0: Keep Subscription").then(()=>{
                setLoading(false);
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    return (
        <Grid container className='confirmed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>We’re glad you stayed</h1>
                </Grid>
                <Grid item className='body-book' >
                We want to sincerely thank you for being part of the Tum to Mom community. This is an incredibly special (and sometimes stressful!) time in your life, and we're grateful to be a part of it and bring you some joy.
                </Grid>
                <div className='line'></div>
                <Grid item className='small-header' >
                    you can close this tab now
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Keep;